// src/hooks/rq/useProPets.js

import { useInfiniteQuery } from '@tanstack/react-query';
import API from '../../api/client';

/**
 * Hook para listar las mascotas de un profesional con React Query.
 * Solo lectura (no toggle), con infinite scroll y polling cada 60s.
 *
 * @param {number|string} professionalId
 * @param {{ species?: string, name?: string }} filters
 */
export function useProPets(professionalId, filters = {}) {
  return useInfiniteQuery({
    // 1️⃣ Clave única basada en profesional y filtros
    queryKey: [
      'proPets',
      professionalId,
      filters.species || 'all',
      filters.name    || 'all'
    ],

    // 2️⃣ Función para fetch de cada página
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        _:    Date.now(),
        ...(filters.species && { species: filters.species }),
        ...(filters.name    && { name:    filters.name    })
      };
      const token = localStorage.getItem('accessToken');
      const { data } = await API.get(
        `/profesionales/${professionalId}/pets/`,
        {
          params,
          ...(token && { headers: { Authorization: `Bearer ${token}` } })
        }
      );
      return data; // { results: [...], next: string|null, ... }
    },

    // 3️⃣ Cómo extraer el siguiente pageParam
    getNextPageParam: lastPage => {
      if (!lastPage.next) return undefined;
      // extrae ?page=N del URL
      try {
        const url = new URL(lastPage.next, window.location.origin);
        return Number(url.searchParams.get('page'));
      } catch {
        // fallback al parseo manual
        const match = lastPage.next.match(/page=(\d+)/);
        return match ? Number(match[1]) : undefined;
      }
    },

    // 4️⃣ Opciones de React Query
    refetchOnMount:          false,
    refetchOnWindowFocus:    false,
    // Polling periódico cada 60 segundos
    refetchInterval:         10000,
    refetchIntervalInBackground: true,
    // 5️⃣ Desactivamos mientras no tengamos professionalId
    enabled: !!professionalId
  });
}
